// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Calendar Container */
.calendar-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 0 auto;
}

/* Year Heading */
.year-heading {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

/* Controls */
.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.year-selector select,
.section-selector select {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
}

/* Year Calendar Grid: 4 columns x 3 rows for 12 months */
.year-calendar-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, auto);
  gap: 16px;
  margin-top: 20px;
}

/* Each Month Box */
.month-box {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

/* Month Name Header */
.month-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

/* Month Events List */
.month-events-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* No Events Message */
.no-events {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #888;
}

/* Event Cell Styling */
.calendar-day.event-cell {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.calendar-day.event-cell:hover {
  background-color: #fff;
}

/* Highlight the current day */
.current-day {
  background-color: #e3f2fd;
  border-color: #64b5f6;
}

.day-number {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.event-title {
  font-size: 12px;
  color: #555;
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

/* Centered Modal Styles */
.modal-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  outline: none;
}

/* Close Button */
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  line-height: 1;
}

@media (max-width: 1200px) {
  .calendar-container {
    padding: 18px;
  }

  .year-calendar-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .calendar-container {
    padding: 16px;
  }

  .year-calendar-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .controls {
    gap: 16px;
  }
}

@media (max-width: 600px) {
  .calendar-container {
    padding: 14px;
  }

  .year-calendar-grid {
    grid-template-columns: 1fr;
  }

  .controls {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .year-selector,
  .section-selector {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .year-selector select,
  .section-selector select {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sections/components/calenderView.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;IAEE,SAAO;EACT;AACF","sourcesContent":["/* Calendar Container */\n.calendar-container {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Year Heading */\n.year-heading {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n/* Controls */\n.controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.year-selector select,\n.section-selector select {\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n}\n\n/* Year Calendar Grid: 4 columns x 3 rows for 12 months */\n.year-calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(3, auto);\n  gap: 16px;\n  margin-top: 20px;\n}\n\n/* Each Month Box */\n.month-box {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Month Name Header */\n.month-name {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n/* Month Events List */\n.month-events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* No Events Message */\n.no-events {\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #888;\n}\n\n/* Event Cell Styling */\n.calendar-day.event-cell {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 6px;\n  background-color: #f9f9f9;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.calendar-day.event-cell:hover {\n  background-color: #fff;\n}\n\n/* Highlight the current day */\n.current-day {\n  background-color: #e3f2fd;\n  border-color: #64b5f6;\n}\n\n.day-number {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.event-title {\n  font-size: 12px;\n  color: #555;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n/* Centered Modal Styles */\n.modal-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n  outline: none;\n}\n\n/* Close Button */\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #333;\n  line-height: 1;\n}\n\n@media (max-width: 1200px) {\n  .calendar-container {\n    padding: 18px;\n  }\n\n  .year-calendar-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .calendar-container {\n    padding: 16px;\n  }\n\n  .year-calendar-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .controls {\n    gap: 16px;\n  }\n}\n\n@media (max-width: 600px) {\n  .calendar-container {\n    padding: 14px;\n  }\n\n  .year-calendar-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .year-selector,\n  .section-selector {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .year-selector select,\n  .section-selector select {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
